export default {
  graduation: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/graduations/resources/props.js